const environment = process.env.REACT_APP_NODE_ENV;

const apiUrl = environment === 'prod' ? 'https://nks-prod-api.azurewebsites.net'
: environment === 'dev' ? 'https://nks-dev-api.azurewebsites.net'
: 'http://localhost:8080'

type DEVURL =
  | "LOKALFORENING_POST"
  | "LOKALFORENING_GET"
  | "STYRET_POST"
  | "STYRET_GET"
  | "EIENDOM_POST"
  | "EIENDOM_GET"
  | "AKTIVITET_POST"
  | "AKTIVITET_GET"
  | "KOS_POST"
  | "KOS_GET"
  | "GAVER_BIDRAG_POST"
  | "GAVER_BIDRAG_GET"
  | "REGNSKAP_POST"
  | "REGNSKAP_GET"
  | "RAPPORT_GET"
  | "LOGIN_POST"
  | "ADMIN_FORENING_SOK_GET"
  | "ADMIN_LASTNED_AAR_RAPPORT_GET"
  | "ADMIN_OPPRETT_FORENING_POST"
  | "ADMIN_OPPDATER_FORENING_PUT"
  | "ADMIN_SLETT_FORENING_DELETE"
  | "LASTNED_RAPPORT_GET"
  | "ADMIN_LASTNED_REGNSKAPSRAPPORT_GET";

export const URLS: Record<DEVURL, string> = {
  LOKALFORENING_POST:                 `${apiUrl}/lokalforening/sendinfo`,
  LOKALFORENING_GET:                  `${apiUrl}/lokalforening/hent/`,
  STYRET_POST:                        `${apiUrl}/styret/sendinfo`,
  STYRET_GET:                         `${apiUrl}/styret/hent/`,
  EIENDOM_POST:                       `${apiUrl}/eov/lagre`,
  EIENDOM_GET:                        `${apiUrl}/eov/hent/`,
  AKTIVITET_POST:                     `${apiUrl}/aktivitet/sendinfo`,
  AKTIVITET_GET:                      `${apiUrl}/aktivitet/hent/`,
  KOS_POST:                           `${apiUrl}/kos/lagre`,
  KOS_GET:                            `${apiUrl}/kos/hent/`,
  GAVER_BIDRAG_POST:                  `${apiUrl}/gaver/lagre`,
  GAVER_BIDRAG_GET:                   `${apiUrl}/gaver/hent/`,
  REGNSKAP_POST:                      `${apiUrl}/regnskap/lagre`,
  REGNSKAP_GET:                       `${apiUrl}/regnskap/hent/`,
  RAPPORT_GET:                        `${apiUrl}/rapport/hent/`,
  LOGIN_POST:                         `${apiUrl}/login_user`,
  ADMIN_FORENING_SOK_GET:             `${apiUrl}/admin/forening/hent/`,
  ADMIN_LASTNED_AAR_RAPPORT_GET:      `${apiUrl}/rapport/admin/arsrapport`,
  LASTNED_RAPPORT_GET:                `${apiUrl}/rapport/hent/`,
  ADMIN_OPPRETT_FORENING_POST:        `${apiUrl}/admin/forening/opprett`,
  ADMIN_OPPDATER_FORENING_PUT:        `${apiUrl}/admin/forening/oppdater/`,
  ADMIN_SLETT_FORENING_DELETE:        `${apiUrl}/admin/forening/slett/`,
  ADMIN_LASTNED_REGNSKAPSRAPPORT_GET: `${apiUrl}/rapport/admin/inntektrapport`,
};
